import { render, staticRenderFns } from "./office-information-edit.vue?vue&type=template&id=c23a956a&scoped=true&lang=pug"
import script from "./office-information-edit.vue?vue&type=script&lang=ts"
export * from "./office-information-edit.vue?vue&type=script&lang=ts"
import style0 from "./office-information-edit.vue?vue&type=style&index=0&id=c23a956a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a956a",
  null
  
)

export default component.exports